import styled from "styled-components";
import { HeadLine1 } from "../../../components/typography/styled";
import { InfoContainer } from '../../../components/info-block/styles'
import {
  responsiveDetailActions,
  responsiveDetailContainer,
  responsiveDetailHeader,
  responsiveDetailTitle,
} from '../../../components/tabs/detail-layout'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 25px 10px 20px;
  position: relative;
  ${responsiveDetailContainer}

  @media screen and (max-width: 768px) {
    > ${InfoContainer} {
      margin-right: 0;
    }
  }
`
export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 0;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;

    > div {
      min-width: 0;
      flex-wrap: wrap;
      gap: 8px;
    }
  }
`
export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width:100%;
  margin-right: 10px;
  ${responsiveDetailHeader}
`

export const RightHeadContainer = styled.div`
  display:flex;
  position: relative;
  ${responsiveDetailActions}
`

export const InstanceName = styled(HeadLine1)`
  color:${({theme}) => theme.palette[800]};
  margin-top:10px;
  margin-bottom:10px;
  max-width:500px;
  word-break: break-word;
  ${responsiveDetailTitle}
`
export const Divider = styled.div`
  width:100%;
  border-bottom: ${({theme}) => `1px solid ${theme.palette[20]}`};
  margin: 30px 0px 30px;
`
